import Vocabulary from './Vocabulary';
export function isVocabulary(track) {
    return track instanceof Vocabulary;
}
export default isVocabulary;    //# sourceMappingURL=isVocabulary.js.map
